import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  && {
    margin-top: 2px;
    max-width: 100%;
    margin-left: 10px;
  }
`;
